export function getCountryName(
  countryCode: string,
  countries: { iso_code: string; country: string }[],
) {
  return countries.find((c) => c.iso_code === countryCode)?.country ?? countryCode;
}
